const CONSTANTS = {
  IS_DISCONNECTED: 'isDisconnected',
  TOKEN: 'ep-authorization',
}

export default CONSTANTS
